import type { IconData } from '@stacksjs/iconify-core'

export const mouseWireless: IconData = {
  "body": "<g fill=\"none\" stroke-width=\"3\"><path fill=\"#8fbffa\" d=\"M24 3c9.168 0 15.662 6.181 15.924 15.345C39.972 20.041 40 21.92 40 24s-.028 3.96-.076 5.655C39.662 38.819 33.168 45 24 45S8.338 38.819 8.076 29.655A198 198 0 0 1 8 24c0-2.08.028-3.96.076-5.654C8.338 9.18 14.832 3 24 3\"/><path stroke=\"#2859c5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M24 3c9.168 0 15.662 6.181 15.924 15.345C39.972 20.041 40 21.92 40 24s-.028 3.96-.076 5.655C39.662 38.819 33.168 45 24 45S8.338 38.819 8.076 29.655A198 198 0 0 1 8 24c0-2.08.028-3.96.076-5.654C8.338 9.18 14.832 3 24 3m0 8v6\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default mouseWireless
